// The Uptime page's rules, shared by its tiles and their click filters, and kept the same as v3's dashboard
// (hephaestus Tasks/dashboard-v2-v3-parity.md: v2 changes wherever v3's rule is the better one)

// a log time is a string, a Firestore Timestamp, or - as the bridges write the logs - epoch milliseconds
export function toActivityDate(value: any): Date | null {
  if (typeof value === 'string' || typeof value === 'number') {
    return new Date(value);
  }

  if (value?.toDate) {
    return value.toDate();
  }

  return null;
}

// Titan Atlas (serial 00...) does not report battery voltages, so it is left out of the battery tiles; remote and panic
// batteries are reported by the remote itself, so they still count
export function isBatteryReportingDevice(deviceId: string): boolean {
  return !deviceId.startsWith('00');
}

// a missing reading is not a low one
export function isLowInternalBattery(deviceId: string, internalBatteryVoltageMilli: any): boolean {
  return isBatteryReportingDevice(deviceId) && typeof internalBatteryVoltageMilli === 'number' && internalBatteryVoltageMilli < 4000;
}

// at or below 6 V is no vehicle battery wired, not a low one
export function isLowVehicleBattery(deviceId: string, vehicleBatteryVoltageMilli: any): boolean {
  return isBatteryReportingDevice(deviceId) && typeof vehicleBatteryVoltageMilli === 'number' && vehicleBatteryVoltageMilli < 10800 && vehicleBatteryVoltageMilli > 6000;
}

export function isVehicleBatteryDisconnected(deviceId: string, vehicleBatteryConnected: any): boolean {
  return isBatteryReportingDevice(deviceId) && vehicleBatteryConnected === false;
}
